// extracted by mini-css-extract-plugin
export var cell = "_6n-4";
export var headerCell = "_6n-2";
export var rowHeader = "_6n-3";
export var table = "_6n-1";
export var tableContainer = "_6n-0";